import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LabelIcon from '@mui/icons-material/Label';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Popup1098F from '@/components/ui/1098PopupF';
// import Popup1099NEC from '@/components/ui/1099PopupNec';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExtensionTo1098 from '@/components/ui/ExtensionTo1098';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form1098F = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Now Accepting <span style="color:#1da94a; font-weight: 600;">Form 1098-E</span> for Tax Year 2024!`,
  //   SubHeading: 'File your student loan interest deductions with ease.  ',
  //   CtaText: ' Get Started Today!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098e`,
  //   isActive: true,
  // };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1098-F Online for 2025 | TaxZerone"
          description="File IRS Form 1098-F for 2025 online with TaxZerone. Report all specified foreign student tuition and related expenses to stay IRS-compliant."
          keywords=""
          canonical="information-returns/efile-irs-form-1098-f/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Popup1098F />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Today&apos;s the Final Day to E-file Form 1099-NEC!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Time is running out! Make sure you file your <b>Form 1099-NEC</b>{' '}
              for non-employee compensation today, <b>January 31st</b>.
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background:
              'linear-gradient(92deg,rgba(13, 27, 42, 1) 0%, rgba(10, 147, 150, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Typography
                component="div"
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 15, sm: 17, md: 18, lg: '1.22rem' },
                  color: '#cdcdca',
                  lineHeight: 1.3,
                }}
              >
                <strong>📢 Deadline Has Passed! </strong> E-File Your 2025{' '}
                <b style={{ fontWeight: 600, color: '#e9d8a6' }}>Form 1098-F</b>{' '}
                Today to Stay IRS-Compliant and Avoid Penalties.
              </Typography>
            </Box>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Start filing now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-file{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1098-F</span>
                </span>{' '}
                for
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Tax Year 2025 with Ease
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Report fines, penalties, and other amounts required by court
                orders or governmental agreements with TaxZerone’s secure and
                IRS-authorized e-file service. Complete the filing in just a few
                simple steps!
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
                  >
                    Start Filing Now!{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      1099-NEC
                    </Box> */}
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1098f-landing-img.webp" />
                <source srcSet="/assets/images/1098f-landing-img.png" />
                <img
                  src="/assets/images/1098f-landing-img.png"
                  alt="E-file Form 1098-F for Tax Year 2025 with Ease"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1098f-landing-img-sm.webp" />
                <source srcSet="/assets/images/1098f-landing-img-sm.png" />
                <img
                  src="/assets/images/1098f-landing-img-sm.png"
                  alt="E-file Form 1098-F for Tax Year 2025 with Ease"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Starting at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with prices as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form for bulk filings
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                What is Form 1098-F?
              </Typography>
              <Typography variant="body1">
                Form 1098-F is used to report fines, penalties, and other
                amounts paid due to a legal settlement or court order.
                Government entities or those acting on their behalf file this
                form when the total payment exceeds $50,000. It helps track
                violations of law, investigation costs, and compliance-related
                payments.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/form-1098f-img.webp" />
                  <source srcSet="/assets/images/form-1098f-img.png" />
                  <img
                    src="/assets/images/form-1098f-img.png"
                    alt=" What is Form 1098-F?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={440}
                    height={394}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                3 Simple Steps to E-file Your IRS Form 1098-F
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing 1098-F electronically with TaxZerone is quick and simple:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1098f-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1098f-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1098f-steps-img.png"
                  alt="Filing 1098-F electronically with TaxZerone is quick and simple:"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Filer & Payer Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Filer & Payer Details
                    </Typography>
                    <Typography variant="body1">
                      Provide the necessary filer and payer details such as
                      name, TIN, and address in the designated fields.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Report Payment Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Report Payment Information
                    </Typography>
                    <Typography variant="body1">
                      Enter the total amount due, violation-related payments,
                      restitution, compliance amounts, and agreement details.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Review & Transmit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Transmit
                    </Typography>
                    <Typography variant="body1">
                      Securely review your return for accuracy and transmit it
                      to the IRS with ease.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
                >
                  E-file Form 1098-F Now!
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: { xs: 2, sm: 4, md: 4 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 900,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Required Information for E-Filing Form 1098-F
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  To e-file Form 1098-F (Fines, Penalties, and Other Amounts)
                  with the IRS, you need to include the following information:
                </Typography>
                <Box
                  sx={{
                    justifyContent: 'center',
                    maxWidth: 650,
                    mx: 'auto',
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Filer’s Information:</b> Name, complete address, and
                        EIN of your entity.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Payer’s Information: </b> Name, complete address,
                        and TIN (SSN for an individual; EIN for a business).
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b>Fine, Penalty, or Other Amount Details </b>
                        <ul>
                          <li> Total amount required to be paid</li>
                          <li>
                            Amount to be paid for violation or potential
                            violation{' '}
                          </li>
                          <li>
                            Restitution/remediation amount & Compliance amount
                          </li>
                        </ul>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b>Order or Agreement Information:</b>
                        <ul>
                          <li> Date of order/agreement</li>
                          <li> Name of the court, or any other entity</li>{' '}
                        </ul>{' '}
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b>Case Information: </b>
                        Case number, Case name or names of parties & Applicable
                        Code
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Paper>
              <Typography variant="body1" sx={{ mt: 3, textAlign: 'center' }}>
                Start your filing process now with TaxZerone and complete your
                1098-F Form in minutes.
              </Typography>
              <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
                >
                  Start Filing Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1098-F E-Filing?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for reporting
                governmental fines, penalties,{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>{' '}
                and other required amounts. Here’s why we are the best choice
                for filing Form 1098-F:
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="IRS Form Validations "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Form Validations
                </Typography>
                <Typography variant="body1">
                  Our system automatically checks for errors, missing details,
                  and formatting issues to ensure your Form submission is
                  accurate and IRS-compliant. Reduce the risk of rejections and
                  avoid penalties with our built-in validation tools.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Filing Made Easy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Filing Made Easy
                </Typography>
                <Typography variant="body1">
                  Need to report multiple fines or penalties? Our bulk upload
                  feature allows you to file multiple Forms at once, saving time
                  and effort. Whether handling a few filings or large-scale
                  submissions, TaxZerone streamlines the process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Instant Recipient Copy Delivery "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Recipient Copy Delivery
                </Typography>
                <Typography variant="body1">
                  Easily share recipient copies through{' '}
                  <span style={{ fontWeight: 600 }}>ZeroneVault</span> for
                  secure digital access or opt for traditional postal mailing.
                  No need for manual printing—send copies quickly and
                  efficiently with just a few clicks.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing for All Filers"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing for All Filers
                </Typography>
                <Typography variant="body1">
                  Enjoy industry-best pricing tailored to your filing needs.
                  Whether submitting a single form or managing{' '}
                  <Hidden smDown>
                    <br />
                  </Hidden>{' '}
                  high-volume filings, TaxZerone offers cost-effective solutions
                  without compromising on quality.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="User-Friendly Filing Process"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  User-Friendly Filing Process
                </Typography>
                <Typography variant="body1">
                  Our simple form-based filing system ensures a hassle-free
                  experience. Just enter the required details, and our platform
                  takes care of the rest—no complex steps or confusing
                  processes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Step-by-Step Filing Assistance"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Step-by-Step Filing Assistance
                </Typography>
                <Typography variant="body1">
                  Need help with a specific section? Our guided filing
                  experience includes{' '}
                  <Hidden smDown>
                    <br />
                  </Hidden>{' '}
                  real-time prompts and expert support to help you complete your
                  Form 1098-F filing with confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          pb: 15,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Form 1098-F filing deadline for the 2025 Tax Year
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/recipient-copies-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/recipient-copies-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/recipient-copies-icon.png"
                      alt="Send Recipient Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Send Recipient Copies
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    February 2, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with the IRS (e-file) "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (e-file)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    March 31, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-file-icon.png"
                      alt="File with the IRS (paper)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (paper)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    March 2, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  TaxZerone recommends filing Form 1098-F online for faster
                  processing, fewer errors, and a lower risk of IRS penalties.
                  <Hidden smDown>
                    <br />
                  </Hidden>{' '}
                  Timely and accurate filing helps you stay on track with IRS
                  requirements.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
                >
                  File 1098-F Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box component="section" sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <ExtensionTo1098 formName="1098 f" formRef="form1098f" />
      </Box>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Get Started with TaxZerone Today
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Filing Form 1098-F online is quick and hassle-free with TaxZerone. You
          can:
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    File accurately with built-in IRS compliance checks
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Stay compliant with IRS reporting requirements
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Save time by filing multiple forms at once.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Benefit from the most affordable pricing in the industry.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: '#f3f3f3' }}>
          Start your e-filing today and complete{' '}
          <span style={{ fontWeight: 600 }}> Form 1098-F</span> in just 3 simple
          steps!
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098f`}
          >
            File Form 1098-F
          </Button>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="f1098-f-faq"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              id="f1098-f-faq"
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              {/* Question 1 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the purpose of the 1098-F form and who needs to file
                  it?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1.5 }}>
                      <strong style={{ fontWeight: 600 }}>
                        IRS Form 1098-F
                      </strong>{' '}
                      (<em>Fines, Penalties, and Other Amounts</em>) is an
                      information return used to track and report specific
                      financial payments tied to legal violations or
                      investigations.
                    </Typography>

                    <Typography variant="body1">
                      <strong style={{ fontWeight: 600 }}>
                        Purpose of Form 1098-F
                      </strong>
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1 } }}>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Tracks Tax Treatment:
                        </strong>{' '}
                        Reports fines, penalties, restitution, remediation, and
                        compliance costs to help determine whether amounts are
                        deductible or nondeductible.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Provides Payment Details:
                        </strong>{' '}
                        Gives the IRS and payer a breakdown of amounts required
                        under a court order, suit, or agreement.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Supports Compliance:
                        </strong>{' '}
                        The government entity files the form with the IRS and
                        provides a copy to the payer for tax reporting.
                      </li>
                    </Box>

                    <Typography variant="body1">
                      <strong style={{ fontWeight: 600 }}>
                        Who needs to file it
                      </strong>
                    </Typography>
                    <Typography variant="body1">
                      The responsibility to file Form 1098-F falls on the
                      government or governmental entity (including certain
                      nongovernmental entities treated as governmental entities)
                      involved in the case.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Who must file Form 1098-F?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Government entities, including federal, state, local, and
                      tribal authorities, must file{' '}
                      <span style={{ fontWeight: 600 }}> Form 1098-F</span> if
                      they impose fines, penalties, or similar monetary
                      assessments. This requirement ensures transparency in
                      reporting financial penalties.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* Question 2 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  When is the deadline to submit the 1098-F form?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1.5 }}>
                      The deadline to submit{' '}
                      <strong style={{ fontWeight: 600 }}>
                        Form 1098-F (Fines, Penalties, and Other Amounts)
                      </strong>{' '}
                      depends on whether you are furnishing copies to the payer
                      or filing with the IRS.
                    </Typography>

                    <Box component="div" sx={{ mt: 1 }}>
                      <TableContainer
                        sx={{
                          border: '1px solid #e5e7ef',
                          borderRadius: '12px',
                          overflowY: 'hidden',
                          overflowX: 'auto',
                        }}
                      >
                        <Table
                          sx={{
                            width: '100%',
                            minWidth: 600,
                            borderCollapse: 'separate',
                            borderSpacing: 0,
                          }}
                          aria-label="1098-F deadlines"
                        >
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#f1f1f1' }}>
                              <TableCell
                                align="center"
                                sx={{
                                  width: '50%',
                                  fontWeight: 700,
                                  fontSize: '14px',
                                  padding: '14px 22px',
                                  borderBottom: '1px solid #e5e7ef',
                                  borderRight: '1px solid #e5e7ef',
                                }}
                              >
                                Recipient/Filing Type
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  width: '50%',
                                  fontWeight: 700,
                                  fontSize: '14px',
                                  padding: '14px 22px',
                                  borderBottom: '1px solid #e5e7ef',
                                }}
                              >
                                Deadline
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            <TableRow>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  verticalAlign: 'top',
                                  borderBottom: '1px solid #e5e7ef',
                                  borderRight: '1px solid #e5e7ef',
                                }}
                              >
                                Furnish Copy to Payer
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  verticalAlign: 'top',
                                  borderBottom: '1px solid #e5e7ef',
                                }}
                              >
                                <strong style={{ fontWeight: 600 }}>
                                  January 31
                                </strong>{' '}
                                of the year following the taxable year
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  verticalAlign: 'top',
                                  borderBottom: '1px solid #e5e7ef',
                                  borderRight: '1px solid #e5e7ef',
                                }}
                              >
                                File Paper Return with IRS
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  verticalAlign: 'top',
                                  borderBottom: '1px solid #e5e7ef',
                                }}
                              >
                                <strong style={{ fontWeight: 600 }}>
                                  February 28
                                </strong>{' '}
                                (if filing fewer than 10 total returns)
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  verticalAlign: 'top',
                                  borderBottom: 'none',
                                  borderRight: '1px solid #e5e7ef',
                                }}
                              >
                                File Electronic Return with IRS
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: '14px 22px',
                                  fontSize: '14px',
                                  verticalAlign: 'top',
                                  borderBottom: 'none',
                                }}
                              >
                                <strong style={{ fontWeight: 600 }}>
                                  March 31
                                </strong>{' '}
                                (required if filing 10 or more information
                                returns)
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1098F;
